import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import MuiBadge, {
  type BadgeProps as MuiBadgeProps,
} from '@mui/material/Badge';
import { classes } from './utils';

export interface BadgeProps extends MuiBadgeProps {}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, color = 'mint-2', onClick, ...props }, ref) => {
    return (
      <MuiBadge
        slotProps={{
          badge: { ref, onClick, className: twMerge(classes.badge, className) },
        }}
        color={color}
        {...props}
      />
    );
  }
);

export default Badge;
